// extracted by mini-css-extract-plugin
module.exports = {"categoryDescription":"yx_q2","footer":"yx_b"};